import { MaterialPrice } from './material-price';
import { MaterialSupplyType } from './material-supply-type';

export interface Material {
    id: number;
    materialNumber: string;
    materialSupplyType: MaterialSupplyType;
    name: string;
    purchaserCode: string;
    // standardPrice: number;
    // strategicPrice: number;
    // manualPrice: number;
    weightInGrams: number;
    pricedUnitOfMeasurementName: string;
    materialPrices: MaterialPrice[];

    // id: number;
    // materialNumber?: string | null;
    // name?: string | null;

    // materialSupplyTypeCode?: string | null;
    // materialSupplyTypeName?: string | null;

    seuPrice?: number | null;
    seuPriceType?: string | null;
    seuComments?: string | null;

    slaLocal?: number | null;
    slaLocalPriceType?: string | null;
    slaLocalComments?: string | null;

    slaExport?: number | null;
    slaExportPriceType?: string | null;
    slaExportComments?: string | null;
}
